import {
  ProductRepository,
  ProductActivityRepository,
  TagRepository,
  LocationsRepository,
  AccountRepository,
  AdditionalDataKeysRepository,
  PlanningPortalRepository,
  TenantRepository,
} from '../core/repositories';
import {
  ProductWebRepository,
  ProductActivityWebRepository,
  TagWebRepository,
  LocationsWebRepository,
  AccountWebRepository,
  AdditionalDataKeysWebRepository,
} from './repositories';
import { PlanningPortalWebRepository } from './repositories/planning-portal/planning-portal-web-repository/planning-portal-web-repository';
import { TenantWebRepository } from './tenant';

export function provideRepositories() {
  return [
    { provide: ProductRepository, useClass: ProductWebRepository },
    {
      provide: ProductActivityRepository,
      useClass: ProductActivityWebRepository,
    },
    { provide: TagRepository, useClass: TagWebRepository },
    { provide: LocationsRepository, useClass: LocationsWebRepository },
    { provide: AccountRepository, useClass: AccountWebRepository },
    {
      provide: AdditionalDataKeysRepository,
      useClass: AdditionalDataKeysWebRepository,
    },
    {
      provide: PlanningPortalRepository,
      useClass: PlanningPortalWebRepository,
    },
    { provide: TenantRepository, useClass: TenantWebRepository },
  ];
}
